export enum EClient {
    BOCOM = 'bocom',
    CMCC = 'CMCC'
}